import React from "react";
import { useParams } from "react-router-dom";
import ContactSet from "./ContactSet";

export default function ContactSetPage() {
  const params = useParams();
  return <ContactSet uuid={params.contactSetUUID} />;
}
